import { render, staticRenderFns } from "./DialogTugBoats.vue?vue&type=template&id=53f8f5b8&"
import script from "./DialogTugBoats.vue?vue&type=script&lang=js&"
export * from "./DialogTugBoats.vue?vue&type=script&lang=js&"
import style0 from "./DialogTugBoats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports